/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Responses_Attachment_Not_EditableInputs */

const es_co2_error_responses_attachment_not_editable = /** @type {(inputs: Error_Responses_Attachment_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los campos de archivo se actualizan subiendo o quitando archivos, no editando su valor.`)
};

/**

* @param {Error_Responses_Attachment_Not_EditableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_responses_attachment_not_editable = /** @type {((inputs?: Error_Responses_Attachment_Not_EditableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Responses_Attachment_Not_EditableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_responses_attachment_not_editable(inputs)
});